export const categories = [
  { slug: 'ssr-nodes', name: 'SSR 节点', icon: 'ri-rocket-line', description: 'ShadowsocksR 协议节点资源，支持混淆加密，适合长期稳定使用' },
  { slug: 'v2ray-nodes', name: 'V2Ray 节点', icon: 'ri-router-line', description: 'V2Ray/VMess 协议节点，支持 WebSocket+TLS，抗干扰能力强' },
  { slug: 'trojan-nodes', name: 'Trojan 节点', icon: 'ri-shield-line', description: 'Trojan 协议节点，伪装 HTTPS 流量，隐蔽性极佳' },
  { slug: 'subscription', name: '订阅链接', icon: 'ri-link-m', description: '一键订阅地址合集，支持 Clash/Quantumult/Surge 等客户端导入' },
  { slug: 'tutorials', name: '使用教程', icon: 'ri-book-open-line', description: '从零开始的节点使用教程，覆盖全平台客户端配置指南' },
  { slug: 'security', name: '安全指南', icon: 'ri-lock-line', description: '节点使用安全注意事项、隐私保护策略与风险防范建议' },
];

export const recommendedNodes = [
  {
    id: 'node-001',
    name: '东京 SSR 高速节点 #01',
    type: 'SSR',
    region: '日本东京',
    speed: '98',
    uptime: '99.7%',
    delay: '42ms',
    encryption: 'aes-256-gcm',
    protocol: 'origin',
    obfs: 'tls1.2_ticket_auth',
  },
  {
    id: 'node-002',
    name: '新加坡 V2Ray 优化节点',
    type: 'V2Ray',
    region: '新加坡',
    speed: '95',
    uptime: '99.5%',
    delay: '68ms',
    encryption: 'auto',
    protocol: 'vmess',
    obfs: 'ws+tls',
  },
  {
    id: 'node-003',
    name: '洛杉矶 Trojan 专线',
    type: 'Trojan',
    region: '美国洛杉矶',
    speed: '92',
    uptime: '99.3%',
    delay: '156ms',
    encryption: 'tls',
    protocol: 'trojan',
    obfs: '-',
  },
  {
    id: 'node-004',
    name: '香港 SSR 低延迟节点',
    type: 'SSR',
    region: '中国香港',
    speed: '96',
    uptime: '99.8%',
    delay: '28ms',
    encryption: 'chacha20-ietf',
    protocol: 'auth_aes128_md5',
    obfs: 'http_simple',
  },
  {
    id: 'node-005',
    name: '首尔 V2Ray 游戏专线',
    type: 'V2Ray',
    region: '韩国首尔',
    speed: '94',
    uptime: '99.4%',
    delay: '55ms',
    encryption: 'auto',
    protocol: 'vmess',
    obfs: 'ws+tls',
  },
  {
    id: 'node-006',
    name: '法兰克福 Trojan 欧洲节点',
    type: 'Trojan',
    region: '德国法兰克福',
    speed: '90',
    uptime: '99.2%',
    delay: '198ms',
    encryption: 'tls',
    protocol: 'trojan',
    obfs: '-',
  },
];

export const articles = [
  {
    slug: '2024-ssr-node-beginners-guide',
    title: '2024 年 SSR 节点新手完全入门指南：从零搭建到稳定使用',
    excerpt: '本文为零基础用户详细讲解 SSR 节点的原理、客户端选择、配置方法及常见问题排查，手把手教你从零搭建属于自己的稳定科学上网环境。',
    content: `<p>随着网络环境的不断变化，越来越多的人开始关注如何使用 SSR（ShadowsocksR）节点来访问全球互联网资源。但对于新手来说，SSR 节点的获取、配置和使用往往充满了困惑。本文将从最基础的概念出发，一步步带你掌握 SSR 节点的完整使用流程。</p>
<h2>什么是 SSR 节点？</h2>
<p>SSR 全称 ShadowsocksR，是 Shadowsocks 的一个分支版本。它通过特定的加密协议和混淆技术，将网络流量伪装成正常的 HTTPS 流量，从而实现稳定、安全的网络访问。SSR 节点的核心优势在于其强大的抗干扰能力和灵活的协议配置选项。</p>
<h3>SSR 节点的工作原理</h3>
<p>简单来说，SSR 节点就像一个中转站：你的设备先将数据加密后发送到 SSR 服务器，服务器解密后将请求转发到目标网站，收到响应后再加密传回你的设备。整个过程对第三方来说是透明的，看起来就像普通的 HTTPS 通信。</p>
<h2>如何选择合适的 SSR 客户端？</h2>
<p>不同平台有不同的推荐客户端：</p>
<ul>
<li><strong>Windows 用户</strong>：推荐使用 ShadowsocksR-Windows 或 Clash for Windows。前者轻量简洁，后者功能更强大，支持规则分流。</li>
<li><strong>macOS 用户</strong>：ClashX Pro 或 Surge 是最佳选择，界面美观且配置灵活。</li>
<li><strong>Android 用户</strong>：ShadowsocksR Android 版或 Surfboard，前者专为 SSR 协议优化。</li>
<li><strong>iOS 用户</strong>：Shadowrocket（小火箭）是首选，支持 SSR/V2Ray/Trojan 等多种协议。</li>
</ul>
<h2>SSR 节点配置参数详解</h2>
<p>一个标准的 SSR 节点链接通常包含以下参数：</p>
<ul>
<li><strong>服务器地址（server）</strong>：SSR 服务器的 IP 地址或域名</li>
<li><strong>端口（port）</strong>：服务器监听端口，常见的有 443、8080、8388 等</li>
<li><strong>密码（password）</strong>：用于加密通信的密钥</li>
<li><strong>加密方式（method）</strong>：推荐使用 aes-256-gcm 或 chacha20-ietf</li>
<li><strong>协议（protocol）</strong>：推荐 origin 或 auth_aes128_md5</li>
<li><strong>混淆（obfs）</strong>：推荐 tls1.2_ticket_auth 或 http_simple</li>
</ul>
<h2>常见问题与解决方案</h2>
<h3>Q: 连接上但无法访问网页？</h3>
<p>检查以下几点：1）确认节点是否过期；2）尝试切换加密方式；3）检查本地防火墙是否阻止了客户端；4）尝试更换 DNS 设置为 8.8.8.8。</p>
<h3>Q: 速度很慢怎么办？</h3>
<p>节点速度受多种因素影响：服务器带宽、物理距离、线路拥堵程度等。建议多备几个不同地区的节点，根据实际使用情况切换最优线路。</p>
<h2>总结</h2>
<p>SSR 节点的使用并不复杂，关键在于选择合适的客户端和可靠的节点资源。希望本指南能帮助新手用户快速上手，享受稳定流畅的网络体验。记得定期更新节点信息，以获得最佳的使用效果。</p>`,
    category: 'ssr-nodes',
    author: '节点指南编辑组',
    date: '2024-12-15',
    readTime: 8,
    tags: ['SSR', '入门教程', '客户端配置', '加密方式'],
  },
  {
    slug: 'v2ray-ws-tls-configuration-tutorial',
    title: 'V2Ray WebSocket+TLS 完整配置教程：打造高隐蔽性节点',
    excerpt: '详解 V2Ray 结合 WebSocket 和 TLS 的配置方法，从服务端搭建到客户端连接，助你构建抗封锁能力极强的代理节点。',
    content: `<p>V2Ray 作为新一代代理工具，凭借其强大的协议支持和灵活的配置方式，已成为当前最主流的节点方案之一。其中，WebSocket（WS）+ TLS 的组合更是因其出色的隐蔽性而备受推崇。</p>
<h2>为什么要选择 V2Ray + WS + TLS？</h2>
<p>传统的代理协议容易被深度包检测（DPI）识别和阻断。而 V2Ray 通过 WebSocket 协议将流量包装成普通的网页浏览流量，再叠加 TLS 加密层，使得流量特征与正常的 HTTPS 网站访问几乎无法区分。</p>
<h2>服务端配置步骤</h2>
<h3>1. 准备工作</h3>
<p>需要一台境外 VPS 服务器（推荐 Ubuntu 20.04+）、一个域名（需将 A 记录指向服务器 IP），以及基本的 Linux 命令行操作能力。</p>
<h3>2. 安装 V2Ray</h3>
<p>使用官方一键安装脚本是最便捷的方式。安装完成后，V2Ray 的配置文件位于 /etc/v2ray/config.json。</p>
<h3>3. 配置 WebSocket + TLS</h3>
<p>核心配置包括：inbound 设置中 protocol 设为 vmess，streamSettings 中 network 设为 ws，security 设为 tls，并指定证书文件路径。同时需要配置一个伪装用的 Web 路径，如 /ray。</p>
<h3>4. 申请 TLS 证书</h3>
<p>推荐使用 acme.sh 或 certbot 申请免费的 Let's Encrypt 证书。确保证书自动续期，避免因证书过期导致节点不可用。</p>
<h2>客户端配置要点</h2>
<p>客户端配置需要与服务端保持一致：地址填域名、端口通常是 443、传输协议选 ws、底层传输安全选 tls、路径填你在服务端设置的伪装路径。建议开启 Mux 多路复用以减少连接延迟。</p>
<h2>性能优化建议</h2>
<p>1. 启用 TCP Fast Open 减少握手延迟；2. 合理设置 Buffer Size；3. 使用 BBR 拥塞控制算法优化传输效率；4. 定期监控服务器负载，必要时升级配置。</p>`,
    category: 'v2ray-nodes',
    author: '节点指南编辑组',
    date: '2024-12-12',
    readTime: 10,
    tags: ['V2Ray', 'WebSocket', 'TLS', '服务端搭建'],
  },
  {
    slug: 'trojan-protocol-advantage-analysis',
    title: 'Trojan 协议深度解析：为什么它是目前最隐蔽的代理方案？',
    excerpt: '深入分析 Trojan 协议的设计理念、技术优势以及与 SSR/V2Ray 的对比，帮助你理解为何 Trojan 成为高要求用户的首选。',
    content: `<p>Trojan 协议自诞生以来，凭借其"以假乱真"的设计理念，迅速在节点圈内获得了极高的评价。本文将深入剖析 Trojan 的技术原理和核心优势。</p>
<h2>Trojan 的设计哲学</h2>
<p>Trojan 的核心思想是：与其尝试隐藏代理流量，不如让它变得与正常的 HTTPS 流量完全一致。Trojan 服务端在接收到请求后，会根据请求内容判断是合法的 Trojan 请求还是普通的 HTTP 请求。</p>
<h3>智能流量分发</h3>
<p>当 Trojan 服务端收到一个请求时：如果是合法的 Trojan 代理请求，它会处理并转发；如果不是（即普通 HTTP 请求），它会将其转发到指定的 Web 服务器（如 Nginx），返回一个正常的网页。这意味着即使被主动探测，服务端也表现得像一个普通的 Web 服务器。</p>
<h2>Trojan 与 SSR/V2Ray 的对比</h2>
<table>
<tr><th>特性</th><th>Trojan</th><th>SSR</th><th>V2Ray</th></tr>
<tr><td>隐蔽性</td><td>极高（模拟HTTPS）</td><td>较高</td><td>高（WS+TLS下）</td></tr>
<tr><td>配置复杂度</td><td>低</td><td>低</td><td>中高</td></tr>
<tr><td>抗干扰能力</td><td>极强</td><td>强</td><td>极强</td></tr>
<tr><td>多路复用</td><td>支持</td><td>不支持</td><td>支持</td></tr>
<tr><td>客户端生态</td><td>良好</td><td>丰富</td><td>丰富</td></tr>
</table>
<h2>Trojan 节点配置快速上手</h2>
<p>Trojan 的配置极为简洁：服务端只需指定端口、密码和证书路径；客户端只需填入服务器地址、端口和密码。没有复杂的协议选项和混淆参数，新手也能在几分钟内完成配置。</p>
<h2>适用场景推荐</h2>
<p>Trojan 特别适合以下场景：1）对隐蔽性有极高要求的用户；2）网络环境严格的地区；3）希望简化配置流程的新手用户；4）需要长期稳定运行的节点服务。</p>`,
    category: 'trojan-nodes',
    author: '节点指南编辑组',
    date: '2024-12-10',
    readTime: 7,
    tags: ['Trojan', '协议对比', '安全分析', '隐蔽性'],
  },
  {
    slug: 'free-node-subscription-links-collection-2024-dec',
    title: '2024年12月免费节点订阅链接合集：每日更新精选',
    excerpt: '整理当前可用的免费节点订阅链接，涵盖 Clash/YAML/Base64 等多种格式，每日更新确保可用性，附带测速结果参考。',
    content: `<p>为了让广大用户能够便捷地获取最新免费节点资源，我们每日整理并测试以下订阅链接。所有链接均经过可用性验证，确保你能即拿即用。</p>
<h2>订阅链接使用说明</h2>
<p>订阅链接是一段 URL 地址，你只需将其复制到支持订阅功能的客户端（如 Clash、Quantumult、Surge 等）中，客户端会自动拉取并更新节点列表，无需手动逐个添加。</p>
<h3>常用客户端订阅导入方法</h3>
<ul>
<li><strong>Clash Verge</strong>：配置 → 订阅 → 新增 → 粘贴链接 → 确定</li>
<li><strong>Surge</strong>：首页 → 从 URL 下载配置 → 粘贴链接</li>
<li><strong>Shadowrocket</strong>：首页 → 右上角 + → 类型选 Subscribe → 粘贴链接</li>
<li><strong>Quantumult X</strong>：设置 → 节点 → 引用 → 粘贴链接</li>
</ul>
<h2>本月精选订阅链接</h2>
<p>以下链接经过 2024年12月 测试，延迟数据为该月平均值：</p>
<h3>Clash 格式订阅</h3>
<ul>
<li>链接 A：综合节点池，平均延迟 85ms，在线率 98%+</li>
<li>链接 B：亚洲优化线路，平均延迟 52ms，适合国内用户</li>
<li>链接 C：欧美专线节点，平均延迟 180ms，带宽充足</li>
</ul>
<h3>Base64 格式订阅</h3>
<ul>
<li>链接 D：SSR 节点专集，提供多种加密方式</li>
<li>链接 E：V2Ray 节点合集，支持 vmess+vless</li>
</ul>
<h2>订阅链接失效怎么办？</h2>
<p>免费订阅链接可能因服务器维护、流量耗尽或域名变更而暂时失效。遇到此情况：1）等待24小时后重试；2）关注本页面的每日更新；3）加入我们的电报频道获取最新备用链接。</p>
<h2>使用建议</h2>
<p>免费节点资源有限，高峰时段可能出现拥堵。建议配置多个订阅链接作为备用，或使用客户端的自动切换功能，当主节点不可用时自动切换到备用节点。</p>`,
    category: 'subscription',
    author: '节点指南编辑组',
    date: '2024-12-14',
    readTime: 6,
    tags: ['订阅链接', '免费节点', 'Clash', '每日更新'],
  },
  {
    slug: 'node-speed-test-methodology-comparison',
    title: '免费节点测速方法全对比：哪种方式最准确？',
    excerpt: '对比多种节点测速工具和方法，包括 Speedtest、iperf3、自定义脚本等，帮你找到最适合的测速方案。',
    content: `<p>选择节点时，速度是最重要的考量因素之一。但不同的测速方法和工具可能给出差异较大的结果。本文将系统性地对比各种测速方案，帮助你做出更准确的选择。</p>
<h2>常用测速工具横向对比</h2>
<table>
<tr><th>工具</th><th>优点</th><th>缺点</th><th>推荐场景</th></tr>
<tr><td>Speedtest CLI</td><td>结果直观、支持多节点</td><td>可能被 QoS 限速</td><td>日常快速测试</td></tr>
<tr><td>iperf3</td><td>专业精准、可定制</td><td>需要服务端配合</td><td>精确测速</td></tr>
<tr><td>自定义脚本</td><td>灵活、可批量</td><td>需要编程能力</td><td>自动化测试</td></tr>
<tr><td>在线测速站</td><td>无需安装</td><td>结果不稳定</td><td>临时参考</td></tr>
</table>
<h2>影响测速结果的因素</h2>
<p>测速结果并非绝对准确，以下因素可能导致偏差：1）测速时间段（高峰 vs 低谷）；2）目标测速服务器位置；3）本地网络环境波动；4）运营商 QoS 策略；5）代理协议的额外开销。</p>
<h2>最佳测速实践</h2>
<h3>多次测试取平均值</h3>
<p>建议在不同时间段进行至少 3 次测速，取中位值作为参考。单次测速受偶然因素影响较大，多次测试能提供更稳定的结果。</p>
<h3>结合实际使用体验</h3>
<p>测速数据只是参考，最终还要看实际使用体验。一个测速成绩普通的节点，如果在你常用的网站上加载流畅，那就是好节点。</p>
<h2>自动化测速脚本推荐</h2>
<p>对于技术用户，可以编写 Shell 或 Python 脚本实现定时批量测速，自动筛选最优节点。结合 cron 定时任务，可以打造属于自己的节点监控系统。</p>`,
    category: 'tutorials',
    author: '节点指南编辑组',
    date: '2024-12-08',
    readTime: 7,
    tags: ['测速', '工具对比', '性能测试', '自动化'],
  },
  {
    slug: 'node-security-privacy-protection-guide',
    title: '免费节点安全使用指南：保护隐私的 7 个关键步骤',
    excerpt: '使用免费节点时如何保护个人隐私？本文从 DNS 泄露防护、浏览器指纹、日志策略等角度全面解析安全注意事项。',
    content: `<p>使用免费节点虽然方便，但安全风险不容忽视。免费的背后可能隐藏着流量监控、数据收集甚至恶意攻击。以下 7 个关键步骤能帮你最大限度地保护隐私安全。</p>
<h2>第一步：检查 DNS 是否泄露</h2>
<p>即使使用了代理，如果 DNS 查询走的是本地网络而非代理隧道，你的浏览记录仍可能被 ISP 获取。使用 dnsleaktest.com 等工具检测是否存在 DNS 泄露。解决方案：在客户端中设置 DNS 为加密 DNS（如 DNS over HTTPS）并强制通过代理转发。</p>
<h2>第二步：启用 WebRTC 泄露防护</h2>
<p>WebRTC 可能导致真实 IP 地址泄露。在浏览器中禁用 WebRTC，或使用支持 WebRTC 防护的代理客户端。</p>
<h2>第三步：注意浏览器指纹</h2>
<p>即使 IP 地址隐藏了，浏览器指纹（Canvas、WebGL、字体列表等）仍可能用于追踪用户。使用隐私浏览器（如 Tor Browser）或安装反指纹插件可以降低风险。</p>
<h2>第四步：警惕免费节点的日志策略</h2>
<p>免费节点提供商可能会记录用户的访问日志。使用前务必了解其隐私政策。理想情况下，选择明确承诺"零日志"政策的节点。</p>
<h2>第五步：敏感操作使用额外加密</h2>
<p>涉及金融交易、账号登录等敏感操作时，即使使用了代理，也建议配合 VPN 或端到端加密工具，形成多层防护。</p>
<h2>第六步：定期更换节点</h2>
<p>长期使用同一个节点不利于隐私保护。建议定期更换节点和订阅链接，降低被追踪和特征分析的风险。</p>
<h2>第七步：保持软件更新</h2>
<p>代理客户端和操作系统的安全更新至关重要。漏洞可能被利用来绕过代理保护，务必及时更新。</p>`,
    category: 'security',
    author: '节点指南编辑组',
    date: '2024-12-06',
    readTime: 8,
    tags: ['安全', '隐私保护', 'DNS泄露', '浏览器指纹'],
  },
  {
    slug: 'clash-multi-platform-configuration-complete-guide',
    title: 'Clash 全平台配置完整指南：Windows/macOS/Android/iOS 一网打尽',
    excerpt: 'Clash 是目前最流行的代理客户端之一，本文覆盖四个主流平台的安装、配置、规则编写及高级技巧。',
    content: `<p>Clash 凭借其强大的规则分流能力和美观的界面设计，已成为节点用户最喜爱的代理客户端。本文将详细介绍 Clash 在全平台的配置方法。</p>
<h2>Clash for Windows 配置</h2>
<p>下载安装后，在 Profiles 页面粘贴订阅链接或导入配置文件。在 Proxies 页面选择节点，支持按延迟排序。规则模式推荐使用 Rule，日常浏览走代理，国内网站直连，兼顾速度与可用性。</p>
<h2>Clash Verge（Windows/macOS/Linux）</h2>
<p>Clash Verge 是基于 Tauri 的现代化 Clash 客户端，支持 Windows、macOS 和 Linux。界面更加简洁，内置 Clash.Meta 内核，支持更多协议。配置方法与 Clash for Windows 类似。</p>
<h2>Clash for Android</h2>
<p>在 Google Play 或 GitHub 下载 Clash for Android。支持订阅链接导入、二维码扫描添加节点。通知栏快捷切换功能非常实用。</p>
<h2>Stash（iOS）</h2>
<p>iOS 平台推荐 Stash（原 Clash for iOS），支持 Rule Set、Script 等高级功能。通过 TestFlight 或 App Store 安装，支持订阅链接和手动配置。</p>
<h2>规则编写进阶</h2>
<p>掌握 Clash 规则语法可以让你更精细地控制流量走向：DOMAIN-SUFFIX 匹配域名后缀、GEOIP 按地理位置分流、IP-CIDR 匹配 IP 段。合理编写规则能让国内网站秒开、国外内容流畅加载。</p>`,
    category: 'tutorials',
    author: '节点指南编辑组',
    date: '2024-12-04',
    readTime: 9,
    tags: ['Clash', '客户端配置', '规则分流', '全平台'],
  },
  {
    slug: 'free-ssr-node-server-deployment-tutorial',
    title: '零成本搭建自己的 SSR 节点服务器：VPS 从选购到上线全流程',
    excerpt: '手把手教你用免费云服务器或低价 VPS 搭建属于自己的 SSR 节点，掌握完全控制权，告别对第三方节点的依赖。',
    content: `<p>与其到处寻找免费节点，不如自己动手搭建一个！本文将带你从选购 VPS 开始，一步步完成属于自己的 SSR 节点服务器部署。</p>
<h2>第一步：选购合适的 VPS</h2>
<p>对于个人使用，1核 CPU + 512MB 内存 + 10GB SSD 的配置完全足够。推荐选择亚洲节点的 VPS（如日本、新加坡、香港），延迟更低。价格通常在每月 $3-$5 美元左右。部分服务商还提供新用户免费试用额度。</p>
<h2>第二步：系统环境准备</h2>
<p>推荐使用 Ubuntu 20.04/22.04 LTS 系统。首次登录后先更新系统：apt update && apt upgrade -y。安装必要的工具如 curl、wget、vim 等。</p>
<h2>第三步：一键安装 SSR</h2>
<p>使用知名的一键安装脚本，只需运行一条命令即可完成 SSR 服务端的安装和基础配置。脚本会自动处理依赖安装、端口开放和防火墙规则。</p>
<h2>第四步：优化与加速</h2>
<p>安装完成后，可以启用 BBR 加速算法以提升 TCP 传输效率。此外，调整 SSR 的加密方式和协议参数也能进一步优化性能。</p>
<h2>第五步：客户端连接测试</h2>
<p>使用任意 SSR 客户端填入服务器 IP、端口、密码和加密方式，测试连接是否正常。建议多设备同时测试，确保稳定性。</p>`,
    category: 'ssr-nodes',
    author: '节点指南编辑组',
    date: '2024-12-02',
    readTime: 10,
    tags: ['SSR', 'VPS', '自建节点', '服务器搭建'],
  },
  {
    slug: 'v2ray-nginx-cdn-hidden-proxy-setup',
    title: 'V2Ray + Nginx + CDN 三层伪装方案：让代理流量彻底隐身',
    excerpt: '结合 V2Ray、Nginx 反向代理和 CDN 加速，构建难以被检测的三层伪装代理架构，大幅提升节点存活率。',
    content: `<p>对于节点搭建者来说，让服务器不被封锁是最核心的目标。本文介绍的 V2Ray + Nginx + CDN 三层伪装方案，是目前公认最有效的防护架构之一。</p>
<h2>架构概览</h2>
<p>这套方案的核心思路是：用户流量先经过 CDN 节点、再到达 Nginx 反向代理、最后才到 V2Ray 后端。每一层都起到了伪装和分流的作用，使得深度包检测难以识别代理流量。</p>
<h3>第一层：CDN</h3>
<p>用户连接的是 CDN 节点的 IP，而非真实服务器 IP。即使被针对，也只会影响 CDN 节点。推荐使用 Cloudflare CDN（免费计划即可），其全球节点分布广泛，对亚洲线路有较好的优化。</p>
<h3>第二层：Nginx</h3>
<p>Nginx 充当反向代理和流量分发器。根据请求路径决定将流量转发到 V2Ray 还是返回普通的网页内容。这确保了服务器始终表现为一个正常的 Web 站点。</p>
<h3>第三层：V2Ray</h3>
<p>V2Ray 仅监听本地回环地址，不直接暴露在公网。所有到达 V2Ray 的请求都经过了 CDN 和 Nginx 的过滤，安全性大幅提升。</p>
<h2>部署步骤</h2>
<p>1. 安装并配置 V2Ray（监听 127.0.0.1）；2. 安装 Nginx 并配置反向代理规则；3. 申请 SSL 证书并启用 HTTPS；4. 将域名接入 Cloudflare CDN 并开启代理模式；5. 测试全链路连通性。</p>
<h2>注意事项</h2>
<p>使用 CDN 可能会略微增加延迟，但带来的安全性提升远远超过这点代价。建议选择与 VPS 同区域的 CDN 节点以最小化延迟影响。</p>`,
    category: 'v2ray-nodes',
    author: '节点指南编辑组',
    date: '2024-11-28',
    readTime: 11,
    tags: ['V2Ray', 'Nginx', 'CDN', '高级配置'],
  },
  {
    slug: 'trojan-go-advanced-features-exploration',
    title: 'Trojan-Go 高级功能探索：多路复用、WebSocket 与 CDN 穿透',
    excerpt: 'Trojan-Go 是 Trojan 协议的 Go 语言实现，新增了多项实用特性。本文详细介绍其多路复用、WebSocket 支持和 CDN 穿透能力。',
    content: `<p>Trojan-Go 作为 Trojan 协议的增强实现，在保持原协议简洁性的同时，引入了多项实用特性，使其在复杂网络环境下的表现更加出色。</p>
<h2>Trojan-Go vs 原版 Trojan</h2>
<p>Trojan-Go 使用 Go 语言重写，不仅继承了原版的优秀基因，还新增了：1）多路复用（Mux），减少连接开销；2）WebSocket 传输支持；3）CDN 穿透能力（配合 Cloudflare 等服务）；4）更低的资源占用和更高的并发性能。</p>
<h2>多路复用详解</h2>
<p>多路复用允许多个请求共享同一个 TCP 连接，避免了频繁建立和断开连接的开销。在高并发场景下（如同时打开多个网页），多路复用能显著降低延迟和资源消耗。Trojan-Go 默认开启 Mux 功能，无需额外配置。</p>
<h2>WebSocket 支持</h2>
<p>在某些网络环境下，WebSocket 比原生 TCP 更容易穿透防火墙。Trojan-Go 支持将 Trojan 流量包装在 WebSocket 帧中，再配合 TLS 加密，实现双重保护。</p>
<h2>CDN 穿透实战</h2>
<p>结合 Cloudflare CDN，可以将 Trojan-Go 的流量伪装成普通的 WebSocket over TLS 连接。配置要点：服务端启用 WS 传输、客户端指定正确的 Host 和路径、域名开启 Cloudflare 代理（橙色云朵）。</p>`,
    category: 'trojan-nodes',
    author: '节点指南编辑组',
    date: '2024-11-25',
    readTime: 8,
    tags: ['Trojan-Go', '多路复用', 'WebSocket', 'CDN'],
  },
  {
    slug: 'node-usage-dns-leak-prevention',
    title: '使用节点时的 DNS 泄露问题：检测方法与彻底解决方案',
    excerpt: 'DNS 泄露是代理使用中最常见的隐私漏洞之一。本文教你如何检测 DNS 泄露，并提供多种彻底解决方案。',
    content: `<p>很多用户以为连上节点就万事大吉了，但实际上 DNS 泄露是一个极易被忽视的安全隐患。本文将深入剖析 DNS 泄露的原理和解决方案。</p>
<h2>什么是 DNS 泄露？</h2>
<p>当你访问一个网站时，浏览器首先需要通过 DNS 将域名解析为 IP 地址。如果这个 DNS 查询没有通过代理隧道，而是直接发送给了本地 ISP 的 DNS 服务器，那么你的上网记录就有可能被记录和追踪。这就是 DNS 泄露。</p>
<h2>如何检测 DNS 泄露？</h2>
<p>访问 dnsleaktest.com 或 ipleak.net 等在线检测工具。如果页面上显示的 DNS 服务器来自你的 ISP 而非节点所在地区，说明存在 DNS 泄露。</p>
<h2>解决方案</h2>
<h3>方案一：客户端强制 DNS 走代理</h3>
<p>大部分代理客户端都提供"通过代理发送 DNS 查询"的选项，务必开启此功能。</p>
<h3>方案二：使用加密 DNS</h3>
<p>配置 DNS over HTTPS（DoH）或 DNS over TLS（DoT），例如使用 Cloudflare 的 1.1.1.1 或 Google 的 8.8.8.8。加密 DNS 可以防止 ISP 窥探你的 DNS 查询内容。</p>
<h3>方案三：系统级 DNS 设置</h3>
<p>在操作系统网络设置中手动指定 DNS 服务器地址，避免使用 ISP 自动分配的 DNS。</p>`,
    category: 'security',
    author: '节点指南编辑组',
    date: '2024-11-22',
    readTime: 6,
    tags: ['DNS泄露', '安全', '隐私', 'DoH'],
  },
  {
    slug: 'quantumult-x-advanced-rules-writing',
    title: 'Quantumult X 高级规则编写指南：精准分流与策略组配置',
    excerpt: '深入讲解 Quantumult X 的规则语法，从基础的分流规则到复杂的策略组配置，让你的代理使用更加智能高效。',
    content: `<p>Quantumult X 是 iOS 平台功能最强大的代理客户端之一，其规则系统灵活度极高。掌握规则编写技巧，能让你的代理使用体验提升一个档次。</p>
<h2>规则基本语法</h2>
<p>Quantumult X 的规则由三部分组成：类型、匹配条件和策略。支持的类型包括 DOMAIN、DOMAIN-SUFFIX、DOMAIN-KEYWORD、IP-CIDR、GEOIP 等。每条规则按顺序匹配，匹配到即停止。</p>
<h2>策略组配置</h2>
<p>策略组允许你为一组规则指定统一的节点选择策略：PROXY 走代理、DIRECT 直连、REJECT 拒绝。还可以创建自定义策略组，如手动选择节点、自动测试延迟选最优等。</p>
<h2>实用规则集推荐</h2>
<p>1. 去广告规则：屏蔽常见广告域名，提升浏览体验；2. 国内直连规则：将国内网站设为直连，减少代理流量消耗；3. 流媒体解锁规则：针对 Netflix、YouTube 等流媒体指定优化节点。</p>
<h2>规则调试技巧</h2>
<p>使用 Quantumult X 的日志功能查看请求匹配了哪条规则，发现分流问题后及时调整规则顺序和匹配条件。善用"最终策略"作为兜底选项。</p>`,
    category: 'tutorials',
    author: '节点指南编辑组',
    date: '2024-11-20',
    readTime: 7,
    tags: ['Quantumult X', '规则编写', 'iOS', '分流策略'],
  },
  {
    slug: 'free-node-risk-assessment-2024',
    title: '2024 年免费节点使用风险评估：你可能不知道的 5 大隐患',
    excerpt: '免费节点虽然诱人，但背后潜藏着多种安全风险。本文客观分析免费节点常见的 5 大安全隐患及应对策略。',
    content: `<p>免费节点对于预算有限的用户来说确实有吸引力，但"天下没有免费的午餐"这句话在节点领域同样适用。了解以下 5 大风险，能让你在使用免费节点时更加谨慎。</p>
<h2>风险一：流量劫持与中间人攻击</h2>
<p>部分恶意免费节点会对用户流量进行劫持，在网页中插入广告代码、挖矿脚本，甚至篡改下载文件。建议：尽量选择有口碑的节点提供方，避免使用来源不明的节点。</p>
<h2>风险二：数据收集与隐私泄露</h2>
<p>免费节点提供方可能通过记录用户访问日志来获利。你的浏览历史、账号信息可能被收集和出售。建议：不要在免费节点环境下登录重要账号。</p>
<h2>风险三：恶意软件注入</h2>
<p>极少数恶意节点甚至会向下载的文件中注入病毒或木马。建议：下载文件后使用杀毒软件扫描，重要软件从官方网站下载。</p>
<h2>风险四：节点稳定性差</h2>
<p>免费节点通常资源有限，用户量大时速度极慢，甚至频繁断线。建议：多备几个节点资源，设置自动切换。</p>
<h2>风险五：法律责任风险</h2>
<p>使用节点访问某些内容可能违反当地法律法规。建议：了解并遵守当地网络使用相关规定。</p>`,
    category: 'security',
    author: '节点指南编辑组',
    date: '2024-11-18',
    readTime: 7,
    tags: ['风险评估', '安全', '隐私', '免费节点'],
  },
  {
    slug: 'node-subscription-auto-update-script',
    title: '节点订阅自动更新脚本：Python 实现定时拉取与可用性检测',
    excerpt: '用 Python 编写一个自动化脚本，实现订阅链接的定时拉取、节点可用性检测和自动切换，彻底解放双手。',
    content: `<p>手动更新节点订阅既繁琐又容易遗漏。本文将教你用 Python 编写一个自动化脚本，实现订阅链接的定时拉取、节点测试和智能切换。</p>
<h2>技术方案设计</h2>
<p>脚本需要实现以下功能：1）从多个订阅链接拉取节点配置；2）对节点进行连通性和延迟测试；3）按延迟排序并筛选可用节点；4）输出最优节点配置到客户端配置文件；5）通过 cron 或 systemd timer 定时执行。</p>
<h2>核心代码实现</h2>
<p>使用 requests 库拉取订阅内容，base64 解码获取节点列表。使用 socket 库进行 TCP 连通性测试，测量连接耗时。将结果写入 JSON 格式的配置文件中。</p>
<h2>集成到客户端</h2>
<p>大多数代理客户端支持指定配置文件路径。将脚本输出的配置文件路径设置到客户端中，配合文件监控功能，可以实现节点变更后的自动重载。</p>
<h2>进阶功能</h2>
<p>1）Telegram Bot 推送：节点可用性变化时通过 Telegram Bot 通知；2）Web 面板：搭建简易 Web 面板展示节点状态；3）分流规则自动适配：根据节点地区自动调整分流规则。</p>`,
    category: 'tutorials',
    author: '节点指南编辑组',
    date: '2024-11-15',
    readTime: 9,
    tags: ['Python', '自动化', '脚本', '订阅更新'],
  },
  {
    slug: 'v2ray-vless-xtls-vision-protocol',
    title: 'VLESS + XTLS Vision 协议详解：V2Ray 最新一代代理方案',
    excerpt: 'VLESS 是 V2Ray 社区推出的轻量级协议，配合 XTLS Vision 流量控制，在性能和隐蔽性方面均有突破性提升。',
    content: `<p>VLESS + XTLS Vision 是 V2Ray 生态中最新、最先进的代理方案组合。本文将带你了解这套方案的技术原理和实际配置方法。</p>
<h2>VLESS 协议简介</h2>
<p>VLESS 是 VMess 的轻量化版本，去除了冗余的加密层。它以"无状态、轻量级"为设计理念，将加密工作完全交给 TLS，减少不必要的加解密开销，从而提升性能。</p>
<h2>XTLS Vision 流量控制</h2>
<p>XTLS Vision 是 XTLS 的核心创新。传统 TLS 代理方案中，数据会经过两次 TLS 处理（客户端一次、服务端一次），XTLS Vision 通过智能识别 TLS 流量特征，在特定场景下减少一次 TLS 处理，大幅降低 CPU 占用和延迟。</p>
<h2>VLESS + XTLS 配置实战</h2>
<p>服务端配置需要指定 "flow": "xtls-rprx-vision"，并确保 TLS 证书配置正确。客户端需要选择支持 XTLS 的内核（如 Xray-core），配置参数与服务端保持一致。</p>
<h2>性能对比测试</h2>
<p>在同等硬件条件下，VLESS + XTLS Vision 的吞吐量比传统 VMess + WS + TLS 高出约 30-50%，延迟降低约 20%。对于大流量场景（如视频播放、大文件下载），优势尤为明显。</p>`,
    category: 'v2ray-nodes',
    author: '节点指南编辑组',
    date: '2024-11-12',
    readTime: 8,
    tags: ['VLESS', 'XTLS', 'V2Ray', '性能优化'],
  },
];

export const faqs = [
  {
    question: '免费节点和付费节点有什么区别？',
    answer: '免费节点通常带宽有限、用户众多，速度和稳定性不如付费节点。付费节点提供专属带宽、更高在线率和客服支持。对于日常轻度使用，优质免费节点完全可以满足需求；但对速度、稳定性有较高要求的用户，建议考虑付费方案。',
  },
  {
    question: '为什么节点经常断开连接？',
    answer: '节点断开可能由以下原因导致：1）服务器端网络波动或维护；2）本地网络环境变化；3）节点配置过期；4）客户端版本过旧。建议多备几个不同地区/协议的节点，并开启客户端的自动重连功能。',
  },
  {
    question: '如何判断一个节点是否安全？',
    answer: '可以从以下几个方面判断：1）节点提供方是否公开隐私政策；2）是否承诺不记录用户日志；3）社区口碑和用户评价；4）技术支持是否及时。优先选择知名、有长期运营记录的节点服务。',
  },
  {
    question: '什么是订阅链接？如何使用？',
    answer: '订阅链接是一个 URL 地址，包含一批节点配置信息。你只需将该链接粘贴到支持订阅功能的代理客户端（如 Clash、Shadowrocket 等），客户端会自动拉取并更新节点列表。订阅链接通常会定期更新，确保节点信息的时效性。',
  },
  {
    question: '不同协议（SSR/V2Ray/Trojan）该如何选择？',
    answer: 'SSR 配置简单、客户端成熟，适合新手；V2Ray 功能强大、扩展性好，适合有一定技术基础的用户；Trojan 隐蔽性最佳，适合对安全要求高的场景。建议至少掌握两种协议，根据实际网络环境灵活切换。',
  },
  {
    question: '使用节点是否合法？',
    answer: '使用节点工具本身在大多数国家是合法的，但通过节点访问某些受限制的内容可能违反当地法律法规。建议用户了解并遵守所在地区的相关法律，合理合法地使用节点工具，主要用于学术研究、技术学习等合法用途。',
  },
];

export const testimonials = [
  {
    name: '李明',
    role: '软件工程师',
    content: '这个网站整理的节点资源非常靠谱，每日更新让我再也不用到处找节点了。特别是测速数据很真实，帮我节省了大量筛选时间。',
    rating: 5,
  },
  {
    name: '王小红',
    role: '大学生',
    content: '教程写得特别详细，我一个文科生都能跟着搭建自己的节点。推荐的客户端和配置方案都很实用，强烈推荐给新手！',
    rating: 5,
  },
  {
    name: '张伟',
    role: '自由职业者',
    content: '安全指南部分让我意识到之前的使用方式存在很大隐患。现在按照指南配置后，使用起来安心多了。网站内容质量很高。',
    rating: 5,
  },
  {
    name: '陈雪',
    role: '跨境电商运营',
    content: '订阅链接合集太方便了，一键导入就能用。更新的频率也很稳定，基本每天都有新的可用节点。已经推荐给好几个同事了。',
    rating: 4,
  },
  {
    name: '刘强',
    role: '网络安全研究员',
    content: '从专业角度看，这个网站对节点的技术分析很到位。Trojan 协议那篇文章写得尤其透彻，看得出编辑团队有深厚的技术功底。',
    rating: 5,
  },
];